import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { Wrench, Search } from "lucide-react";

export default function EquipmentList() {
  const [items, setItems] = useState([]);
  const [companies, setCompanies] = useState({});
  const [q, setQ] = useState("");

  useEffect(() => {
    (async () => {
      const [e, c] = await Promise.all([api.get("/equipment", { params: { q } }), api.get("/companies")]);
      setItems(e.data);
      setCompanies(Object.fromEntries(c.data.map(x => [x.id, x])));
    })();
  }, [q]);

  return (
    <div className="space-y-6">
      <header>
        <div className="text-xs font-mono uppercase tracking-widest text-blue-700 mb-1">Anagrafica</div>
        <h1 className="font-display text-3xl font-bold text-slate-900 flex items-center gap-2"><Wrench size={28} /> Attrezzature e macchinari</h1>
      </header>
      <div className="relative max-w-md">
        <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
        <input placeholder="Cerca tipologia, marca, modello, matricola…" value={q} onChange={(e) => setQ(e.target.value)}
          className="w-full pl-10 pr-3 py-2.5 border border-slate-300 rounded-lg bg-white" />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
        {items.map(e => (
          <Link key={e.id} to={`/attrezzature/${e.id}`} className="card-lift block bg-white border border-slate-200 rounded-lg p-4">
            <div className="font-display font-semibold text-slate-900">{e.tipologia}</div>
            <div className="text-sm text-slate-600 mt-1">{e.marca} {e.modello}</div>
            <div className="text-xs font-mono text-slate-500 mt-1">{e.matricola && `MATR ${e.matricola}`}</div>
            <div className="text-xs text-blue-700 mt-2">{companies[e.company_id]?.ragione_sociale}</div>
          </Link>
        ))}
        {items.length === 0 && <div className="col-span-full text-center text-slate-500 py-10">Nessuna attrezzatura.</div>}
      </div>
    </div>
  );
}
